/* eslint-disable import/no-unresolved */
import { lazy, Suspense } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';

import Loader from '@/components/Loader';

const Layout = lazy(() => import('@/layout'));
const SignIn = lazy(() => import('@/pages/SignIn'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const Customers = lazy(() => import('@/pages/Customers'));
const Tables = lazy(() => import('@/pages/Tables'));
const TableID = lazy(() => import('@/pages/TableID'));
const Items = lazy(() => import('@/pages/Items'));
const Orders = lazy(() => import('@/pages/Orders'));
const KOTList = lazy(() => import('@/pages/KOTList'));
const Settings = lazy(() => import('@/pages/Settings'));
const InvoiceList = lazy(() => import('@/pages/InvoiceList'));
const Report = lazy(() => import('@/pages/Report'));
const GenerateInvoice = lazy(() => import('@/pages/GenerateInvoice'));
const GenerateBill = lazy(() => import('@/pages/GenerateBill'));
const GenerateKOT = lazy(() => import('@/pages/GenerateKot'));

const Routes = () => (
  <Suspense fallback={<Loader />}>
    <RouterRoutes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="generate-invoice" element={<GenerateInvoice />} />
      <Route path="generate-bill" element={<GenerateBill />} />
      <Route path="generate-kot" element={<GenerateKOT />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="customers" element={<Customers />} />
        <Route path="tables" element={<Tables />} />
        <Route path="tables/:name" element={<TableID />} />
        <Route path="items" element={<Items />} />
        <Route path="orders" element={<Orders />} />
        <Route path="kot-list" element={<KOTList />} />
        <Route path="settings" element={<Settings />} />
        <Route path="invoice-list" element={<InvoiceList />} />
        <Route path="report" element={<Report />} />
      </Route>
      <Route path="*" element={<Dashboard />} />
    </RouterRoutes>
  </Suspense>
);

export default Routes;
